module.exports = __webpack_public_path__ + "media/components/assets/img/icons/star-full-005541b49469d6de847fa7fedbea52d8.svg";